import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'

export const PremiumsBills: FC = () => {
  const { t } = useTranslation('premiumsBills')

  return (
    <ContentLayout
      className="ds-u-padding-bottom--7"
      heading={t('premiumsBillsHeading')}
      width="wide"
      withPrintButton
    >
    </ContentLayout>
  )
}
